import type { CSSProperties } from "react";

export function domRectsIntersect(
  a: DOMRect | { top: number; left: number; bottom: number; right: number },
  b: DOMRect,
): boolean {
  return a.bottom > b.top && a.top < b.bottom && a.right > b.left && a.left < b.right;
}

/** 将轴对齐矩形裁剪到容器视口内；与容器无交则 `null`（与末尾加行条逻辑一致）。 */
export function clipLayoutRectToContainer(
  rect: { top: number; left: number; width: number; height: number },
  clip: DOMRect | null,
): { top: number; left: number; width: number; height: number } | null {
  if (!clip) return null;
  const left = Math.max(rect.left, clip.left);
  const top = Math.max(rect.top, clip.top);
  const right = Math.min(rect.left + rect.width, clip.right);
  const bottom = Math.min(rect.top + rect.height, clip.bottom);
  const width = right - left;
  const height = bottom - top;
  if (width <= 1 || height <= 1) return null;
  return { left, top, width, height };
}

/** `position: fixed` 且 `left/top/width/height` 为数字时的裁剪（用于握把、轴高亮层）。 */
export function clipFixedStyleToContainer(style: CSSProperties | null, clip: DOMRect | null): CSSProperties | null {
  if (!style || !clip) return null;
  const L = style.left;
  const T = style.top;
  const W = style.width;
  const H = style.height;
  if (typeof L !== "number" || typeof T !== "number" || typeof W !== "number" || typeof H !== "number") {
    return null;
  }
  const out = clipLayoutRectToContainer({ left: L, top: T, width: W, height: H }, clip);
  if (!out) return null;
  return { ...style, left: out.left, top: out.top, width: out.width, height: out.height };
}
